<template>
  <div class="container">
    <img src='@/assets/image/banner.jpg' class="home-banner">
    <div class="content">
      <div class="title">{{companyInfo.coverTitle}}</div>
      <div class="intro">{{companyInfo.coverIntro}}</div>
      <div class="btn" @click="$router.push('/contact')">contact</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "partA",
    data(){
      return {
        companyInfo:{}
      }
    },
    created() {
      this.$http.get('/api/company/info/list').then((res)=>{
        this.companyInfo = res.data.rows[0]
        console.log('home',this.companyInfo)
      })
    }
  }
</script>

<style scoped>
  .content {
    position: absolute;
    top: 20px;
    left: 8%;
  }

  .home-banner {
    width: 100%;
    height: 975px;
    object-fit: cover;
  }

  .title {
    margin-top: 300px;
    font-size: 60px;
    font-weight: bold;
  }

  .intro {
    width: 544px;
    margin-top: 30px;
    /*text-indent: 2em;*/
    line-height: 28px;
    /*letter-spacing: 0.1em;*/
    color: #768087;
  }

  .btn {
    width: 246px;
    height: 72px;
    margin-top: 48px;
    line-height: 72px;
    text-align: center;
    transition: all .5s;
    color: #fff;
    background-color: #6676e7;
    border-radius: 10px;
    font-size: 30px;
    cursor: pointer;
  }

  .btn:hover {
    transform: scale(1.02);
    background-color: #3a4ccc;
  }

  @media (max-width: 992px) {
    .container {
      /*height: 750px;*/
    }

    .content {
      width: 90%;
      position: relative;
      top: 0;
      left: 0;
      margin: 0 auto;
    }

    .home-banner {
      display: none;
    }

    .title {
      font-size: 16px;
      text-align: center;
    }

    .intro {
      font-size: 12px;
      width: 100%;
      text-indent: 2em;
    }

    .btn {
      width: 100px;
      height: 36px;
      font-size: 16px;
      line-height: 36px;
      border-radius: 5px;
      margin: 30px auto 0;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/home/section/home.vue